import {
  AdminAppAction,
  LoadPlaceErrorAction,
  LoadPlaceRequestAction,
  LoadPlaceSuccessAction,
  PlaceActionType,
  loadImage,
  loadPlaceError,
  loadPlaceSuccess,
} from '../../actions';
import { Epic, ofType } from 'redux-observable';
import {
  GET_PLACE_QUERY,
  GetPlaceData,
  GetPlaceVariables,
} from '../../queries';
import { mergeAll, switchMap } from 'rxjs/operators';
import { AdminAppState } from '../../state';
import { EpicDependencies } from '../epic-dependencies';
import { of } from 'rxjs';

export const loadPlaceEpic: Epic<
  AdminAppAction,
  LoadPlaceSuccessAction | LoadPlaceErrorAction,
  AdminAppState,
  EpicDependencies
> = (action$, state, { client }) =>
  action$.pipe(
    ofType<AdminAppAction, LoadPlaceRequestAction>(
      PlaceActionType.LoadPlaceRequest,
    ),
    switchMap(async (action: LoadPlaceRequestAction) => {
      const { data, errors } = await client.query<
        GetPlaceData,
        GetPlaceVariables
      >({
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        query: GET_PLACE_QUERY,
        variables: {
          id: action.placeKey,
        },
      });

      if (errors) {
        return of(loadPlaceError(action.placeKey, errors));
      } else if (data) {
        const imageActions = data.place.images.map(posterImage =>
          loadImage(posterImage.image.id, {
            id: posterImage.image.id,
            url: posterImage.image.url,
          }),
        );

        const posterImages = data.place.images.map(posterImage => ({
          imageKey: posterImage.image.id,
          type: posterImage.type,
        }));

        return of(
          loadPlaceSuccess(action.placeKey, {
            id: data.place.id,
            description: data.place.description,
            locations:
              data.place.locations.edges.length > 0
                ? [data.place.locations.edges[0].node]
                : [],
            name: data.place.name,
            posterImages,
            tags: data.place.tags.map(tag => tag.name).join(' '),
            pageId: data.place.page ? data.place.page.id : null,
            pageTitle: data.place.page ? data.place.page.title : null,
          }),
          ...(imageActions as any),
        );
      } else {
        throw new Error('No data.');
      }
    }),
    mergeAll(),
  );
